import TwitterButton from '@components/social-media-links/twitter';
import FacebookButton from '@components/social-media-links/facebook';
import LinkedinButton from '@components/social-media-links/linkedin';
import InstagramButton from '@components/social-media-links/instagram';
interface UserSocialButtonPropTypes {
  socialLinks: {
    Twitter: string | null;
    Facebook: string | null;
    Linkedin: string | null;
    Youtube: string | null;
    Instagram: string | null;
  };
}
const UserSocialButtons = ({ socialLinks }: UserSocialButtonPropTypes) => {
  const { Twitter, Facebook, Linkedin, Youtube, Instagram } = socialLinks;
  return (
    <>
      {Twitter && <TwitterButton authorSocialLink={Twitter} />}
      {Facebook && <FacebookButton authorSocialLink={Facebook} />}
      {Linkedin && <LinkedinButton authorSocialLink={Linkedin} />}
      {Instagram && <InstagramButton authorSocialLink={Instagram} />}
    </>
  );
};

export default UserSocialButtons;
